<template>
  <div class="animated fadeIn">
    <div class="row">
      <div
        v-if="showSearchList && !showDetails"
        class="col-md-12"
        style="
          border: solid 1px #ccc;
          background-color: #fbfbfb;
          right: 2px;
          height: auto;
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
          overflow: hidden;
        "
      >
        <div class="form-group row pt-3 align-items-center">
          <div class="col-md-3">
            <div class="input-group">
              <span
                class="btn btn-default btn-outline-dark rounded-0 pointer"
                @click="onClearSearch()"
                v-if="search"
              >
                <i class="fas fa-times-circle"></i>
              </span>
              <b-form-input
                type="text"
                :placeholder="'Digite o CPF ou CNPJ'"
                v-model="search"
                @keyup.enter="onSearch()"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              />
            </div>
          </div>
          <div class="col-md-5 mt-3 mt-sm-0">
            <div class="input-group">
              <span
                class="btn btn-default btn-outline-dark rounded-0 pointer"
                @click="clearInput('nome')"
                v-if="searchNome"
              >
                <i class="fas fa-times-circle"></i>
              </span>
              <b-form-input
                type="text"
                :placeholder="'Digite o Nome do Associado'"
                v-model="searchNome"
                @keyup.enter="onSearch()"
              />
            </div>
          </div>
          <div class="col-md-2 mt-3 mt-sm-0">
            <div class="input-group">
              <b-form-select
                v-model="form.matricula.value"
                :options="form.matricula.options"
              >
                <template slot="first">
                  <option
                    :value="null"
                    disabled
                  >
                    {{ $lang.Common.PlaceholderSelect }}
                  </option>
                </template>
              </b-form-select>
            </div>
          </div>

          <div class="col-md-2 col-sm-12 mt-3 mt-sm-0">
            <div class="row">
              <div class="col-6 pr-1">
                <span
                  v-if="!advancedSearch"
                  class="btn btn-third rounded pointer w-100"
                  @click="onSearch()"
                >
                  <i class="fas fa-search"></i>
                </span>
              </div>
              <div class="col-6 pl-1">
                <!--
                  [07/07/2025] Comentado o atributo v-if="screenW > 768 || advancedSearch" para que o botão fique visível também em telas menores.
                  O motivo original da condição não foi identificado, portanto foi preservado em comentário.
                -->
                <span
                  :class="[
                    'btn btn-default btn-outline-dark rounded pointer w-100',
                    advancedSearch ? '' : 'ml-0'
                  ]"
                  @click="toggleAdvancedSearch()"
                >
                  <i :class="advancedSearch ? 'fas fa-minus' : 'fas fa-plus'"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          id="BuscaAvancada"
          v-if="advancedSearch"
        >
          <div class="form-group row pt-2">
            <div class="col-md-2">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded pointer"
                  @click="clearInput('telefone')"
                  v-if="searchTelefone"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="'Digite o Telefone'"
                  v-model="searchTelefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
            <div class="col-md-2 mt-3 mt-sm-0">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded-0 pointer"
                  @click="clearInput('protocoloCard')"
                  v-if="searchNumProtocoloCard"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="'Digite o número do protocolo'"
                  v-model="searchNumProtocoloCard"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
            <div class="col-md-2 mt-3 mt-sm-0">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded pointer"
                  @click="clearInput('numId')"
                  v-if="searchNumId"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="`Digite o ${$t('associates.number')}`"
                  v-model="searchNumId"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
            <div class="col-md-6 mt-3 mt-sm-0">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded pointer"
                  @click="clearInput('email')"
                  v-if="searchEamil"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="'Digite o Email do Associado'"
                  v-model="searchEamil"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
          </div>
          <div class="form-group row pt-2">
            <div class="col-md-6">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded-0 pointer"
                  @click="clearInput('gr')"
                  v-if="searchGerenteRelacionamento"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="`Digite o Nome do ${$lang.RelationchipManager.ShortLabel}`"
                  v-model="searchGerenteRelacionamento"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
            <div class="col-md-6 mt-3 mt-sm-0">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded-0 pointer"
                  @click="clearInput('gsbr')"
                  v-if="searchGerente"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="`Digite o Nome do ${$t(
                    'associates.gerenteSisbr'
                  )}`"
                  v-model="searchGerente"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
          </div>
          <div class="form-group row pt-2">
            <div class="col-md-5">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded-0 pointer"
                  @click="clearInput('ge')"
                  v-if="searchGrupoEconomico"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="'Digite Código ou o Nome do Grupo Econômico'"
                  v-model="searchGrupoEconomico"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
            <div class="col-md-3 mt-3 mt-sm-0">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded-0 pointer"
                  @click="clearInput('numpa')"
                  v-if="searchNumPa"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="number"
                  :placeholder="'Digite o número do PA'"
                  v-model="searchNumPa"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
            <div class="col-md-4 mt-3 mt-sm-0">
              <div class="input-group">
                <span
                  class="btn btn-default btn-outline-dark rounded-0 pointer"
                  @click="clearInput('regi')"
                  v-if="searchNomeRegional"
                >
                  <i class="fas fa-times-circle"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="'Digite o Nome da Regional'"
                  v-model="searchNomeRegional"
                  @keyup.enter="onSearch()"
                />
              </div>
            </div>
          </div>

          <div class="form-group row pt-2">
            <div class="col-md-4 pb-2">
              <div class="input-group">
                <button
                  type="button"
                  class="btn btn-third btn-sm rounded w-100"
                  v-on:click="toggleAdvancedSearch()"
                  v-b-tooltip.hover
                >
                  <i class="fas fa-undo"></i
                  ><span class="d-md-down-none"> Voltar</span>
                </button>
              </div>
            </div>
            <div class="col-md-4 pb-2">
              <div class="input-group">
                <button
                  type="button"
                  class="btn btn-default btn-outline-dark rounded w-100"
                  v-on:click="onClearSearch()"
                >
                  Limpar Filtros
                </button>
              </div>
            </div>
            <div class="col-md-4 pb-2">
              <div class="input-group">
                <button
                  type="button"
                  class="btn btn-third btn-sm w-100 rounded"
                  v-on:click="onSearch()"
                  v-b-tooltip.hover
                >
                  <i class="fas fa-search"></i
                  ><span class="d-md-down-none"> Buscar</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12">
            <div class="title-line"></div>
            <h4><i class="fas fa-users"></i> Associados</h4>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12 d-none">
            <span class="pl-2"> Hoje <i class="fas fa-chevron-down"></i> </span>
          </div>
        </div>
        <div class="form-group row">
          <div
            id="associate-list"
            class="col-md-12"
            style="max-height: 942px; overflow: auto"
          >
            <AssociateList
              ref="AssociateList"
              v-on:edit="openAssociatePage"
            />
            <br />
          </div>

          <div
            class="col-md-12 pt-3 pb-3 pb-md-0"
            style="border-top: 1px solid #cfd8dc; background-color: #eceff1"
          >
            <AssociatePagination
              ref="AssociatePagination"
              v-on:LoadPage="LoadPage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import AssociateDetailsTabs from '@/views/private/associate/components/associatedetailsTabs.vue'
import AssociateList from '@/views/private/associate/pages/AssociateList.vue'
import AssociatePage from '@/views/private/associate/pages/AssociatePage.vue'
import AssociatePagination from '@/views/private/associate/pagination/associatepagination.vue'

export default {
  name: 'associate',
  mixins: [ActionsForm],
  data () {
    return {
      search: null,
      searchNome: null,
      searchTelefone: null,
      searchNumId: null,
      searchEamil: null,
      searchGerenteRelacionamento: null,
      searchGerente: null,
      searchGrupoEconomico: null,
      searchNumProtocoloCard: null,
      searchNumPa: null,
      searchNomeRegional: null,
      advancedSearch: false,
      showDetails: false,
      showSearchList: true,
      totalPages: 0,
      pageIndex: 0,
      pageLimit: 12,
      currentPage: 0,
      totalElements: 0,
      numberOfElementsDisplayed: 0,
      screenW: screen.width,
      offset: 0,
      form: {
        matricula: {
          value: null,
          options: [
            {
              text: `${this.$t(
                'associates.capitalAccount'
              ).toUpperCase()} - INATIVO`,
              value: 'INATIVO'
            },
            {
              text: `${this.$t(
                'associates.capitalAccount'
              ).toUpperCase()} - ATIVO`,
              value: 'ATIVO'
            }
          ]
        }
      }
    }
  },
  components: {
    AssociateList,
    AssociatePagination,
    AssociatePage,
    AssociateDetailsTabs
  },
  methods: {
    onLoad () {
      this.form.matricula.value = 'ATIVO'
      this.onSearch()
      /*
      loading.push()
      AssociateRepository.GetAllPaging(this.pageLimit, this.pageIndex)
        .then((response) => {
          this.$refs.AssociateList.associateData = response.data
          this.$refs.AssociatePagination.totalPages = response.data.totalPages
          this.$refs.AssociatePagination.totalElements = response.data.totalElements
          this.$refs.AssociatePagination.numberOfElementsDisplayed = response.data.numberOfElements
          this.$refs.AssociatePagination.offset = response.data.pageable.offset
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
        */
    },
    onClearSearch () {
      this.search = null
      if (this.advancedSearch) {
        this.clearInput()
        this.onClearPaging()
        this.onLoad()
      }
    },
    clearInput (inputName) {
      if (inputName === 'telefone') {
        this.searchTelefone = null
        return
      }
      if (inputName === 'gr') {
        this.searchGerenteRelacionamento = null
        return
      }
      if (inputName === 'gsbr') {
        this.searchGerente = null
        return
      }
      if (inputName === 'numId') {
        this.searchNumId = null
        return
      }
      if (inputName === 'email') {
        this.searchEamil = null
        return
      }
      if (inputName === 'ge') {
        this.searchGrupoEconomico = null
        return
      }
      if (inputName === 'protocoloCard') {
        this.searchNumProtocoloCard = null
        return
      }
      if (inputName === 'numpa') {
        this.searchNumPa = null
        return
      }
      if (inputName === 'regi') {
        this.searchNomeRegional = null
        return
      }

      this.form.matricula.value = 'ATIVO'
      this.search = null
      this.searchNome = null
      this.searchTelefone = null
      this.searchNumId = null
      this.searchEamil = null
      this.searchGerenteRelacionamento = null
      this.searchGerente = null
      this.searchGrupoEconomico = null
      this.searchNumProtocoloCard = null
      this.searchNumPa = null
      this.searchNomeRegional = null
    },
    onClearPaging () {
      this.currentPage = 0
      this.pageIndex = 0
      this.totalElements = 0
      this.numberOfElements = 0
      if (this.$refs.AssociatePagination) {
        this.$refs.AssociatePagination.currentPage = this.currentPage
        this.$refs.AssociatePagination.pageIndex = this.pageIndex
        this.$refs.AssociatePagination.totalElements = this.totalElements
        this.$refs.AssociatePagination.numberOfElementsDisplayed =
          this.numberOfElements
        this.$refs.AssociatePagination.offset = this.offset
      }
    },
    getAllAssociateWithSimpleFilter () {
      loading.push()
      var querry = []
      if (this.search) {
        querry.push('document=' + this.search.replace(/[^\d]+/g, ''))
      }
      if (this.searchNome) {
        querry.push('nomeAssociado=' + encodeURIComponent(this.searchNome))
      }

      if (this.form.matricula.value) {
        querry.push('situacaoMatricula=' + this.form.matricula.value)
      }

      if (querry.length > 0) {
        querry = querry.join('&')
      }
      AssociateRepository.Search(querry, this.pageLimit, this.pageIndex)
        .then((response) => {
          this.$refs.AssociateList.associateData = response.data
          this.$refs.AssociatePagination.totalPages =
            response.data.totalPages - 1 // INDEX
          this.$refs.AssociatePagination.totalElements =
            response.data.totalElements
          this.$refs.AssociatePagination.numberOfElementsDisplayed =
            response.data.numberOfElements
          this.$refs.AssociatePagination.offset = response.data.pageable.offset

          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    getAllAssociateWithAdvancedFilter () {
      loading.push()
      AssociateRepository.Search(
        this.createQuerry(),
        this.pageLimit,
        this.pageIndex
      )
        .then((response) => {
          this.$refs.AssociateList.associateData = response.data
          this.$refs.AssociatePagination.totalPages =
            response.data.totalPages - 1 // INDEX
          this.$refs.AssociatePagination.totalElements =
            response.data.totalElements
          this.$refs.AssociatePagination.numberOfElementsDisplayed =
            response.data.numberOfElements
          this.$refs.AssociatePagination.offset = response.data.pageable.offset

          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    openAssociatePage (associateId) {
      this.$router.replace({
        name: 'AssociatePage',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
      // window.open(routeData.href)
      // this.$router.resolve(0)
    },
    onSearch () {
      this.showDetails = false
      this.onClearPaging()
      this.LoadPage(this.pageIndex)
    },
    onCloseDetails () {
      this.showDetails = false
      this.showSearchList = true
      this.onSearch()
    },
    LoadPage (index) {
      this.currentPage = index
      this.pageIndex = index
      if (
        this.search ||
        this.searchNome ||
        this.form.matricula.value ||
        this.advancedSearch
      ) {
        if (this.advancedSearch) {
          this.getAllAssociateWithAdvancedFilter()
        } else {
          this.getAllAssociateWithSimpleFilter()
        }
      } else {
        this.onLoad()
      }
      window.scrollTo(0, 0)
    },
    toggleAdvancedSearch () {
      this.advancedSearch = !this.advancedSearch
    },
    createQuerry () {
      let querry = []

      if (this.search) {
        querry.push('document=' + this.search.replace(/[^\d]+/g, ''))
      }
      if (this.searchNome) {
        querry.push('nomeAssociado=' + this.searchNome)
      }
      if (this.searchTelefone) {
        querry.push('telefone=' + this.searchTelefone)
      }
      if (this.searchNumId) {
        querry.push('numId=' + this.searchNumId.replace(/[^\d]+/g, ''))
      }
      if (this.searchEamil) {
        querry.push('email=' + this.searchEamil)
      }
      if (this.searchGerenteRelacionamento) {
        querry.push('gerenteRelecionamento=' + this.searchGerenteRelacionamento)
      }
      if (this.searchGerente) {
        querry.push('gerente=' + this.searchGerente)
      }
      if (this.searchGrupoEconomico) {
        querry.push('grupoEconomico=' + this.searchGrupoEconomico)
      }
      if (this.searchNumProtocoloCard) {
        querry.push('protocoloCard=' + this.searchNumProtocoloCard)
      }
      if (this.searchNumPa) {
        querry.push('numeroPA=' + this.searchNumPa)
      }
      if (this.searchNomeRegional) {
        querry.push('nomeRegional=' + this.searchNomeRegional)
      }
      if (this.form.matricula.value) {
        querry.push('situacaoMatricula=' + this.form.matricula.value)
      }

      if (querry.length > 0) {
        querry = querry.join('&')
      }

      return querry
    }
  }
}
</script>
<style scoped>
.title-line {
  width: 40px;
  height: 6px;
  margin: 22px 267px 9px 0px;
  border-radius: 3px;
  background-color: #707070;
}

.bg-crm {
  bottom: 5px;
  position: fixed;
  right: 5px;
  text-align: right;
}

.bg-crm img {
  width: 70%;
}

.box {
  -webkit-box-shadow: 0px -5px 11px #999;
  -moz-box-shadow: 0px -5px 11px #999;
  box-shadow: 0px -5px 11px #999;
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/associate.vue